import { Component, OnInit } from '@angular/core';
import { RoomService } from '../../services/room.service';

@Component({
  selector: 'app-lock-board',
  templateUrl: './lock-board.component.html',
  styleUrls: ['./lock-board.component.scss']
})
export class LockBoardComponent implements OnInit {

  get lockBoard(): boolean {
    return this.roomService.lockBoard;
  }

  set lockBoard(lockBoard: boolean) {
    this.roomService.lockBoard = lockBoard;
  }

  constructor(private roomService: RoomService) { }

  ngOnInit() {
  }

}